"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryPropertiesMap = exports.arbitraryProperty = exports.arbitraryPropertyValue = exports.arbitraryLinkPropertyValue = exports.arbitraryVector3PropertyValue = exports.arbitraryVector2PropertyValue = exports.arbitraryPropertyValueType = void 0;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const vector_1 = require("./vector");
exports.arbitraryPropertyValueType = fast_check_1.default.constantFrom("string", "number", "boolean", "vector2", "vector3", "link");
exports.arbitraryVector2PropertyValue = fast_check_1.default.record({
    type: fast_check_1.default.constant("vector2"),
    data: vector_1.arbitrarySchematicPosition2D,
});
exports.arbitraryVector3PropertyValue = fast_check_1.default.record({
    type: fast_check_1.default.constant("vector3"),
    data: vector_1.arbitraryAutoVector3,
});
exports.arbitraryLinkPropertyValue = fast_check_1.default.record({
    type: fast_check_1.default.constant("link"),
    text: fast_check_1.default.webUrl(),
    url: fast_check_1.default.webUrl(),
});
const arbitraryPropertyValue = (propertyTypeConstraint) => {
    return (propertyTypeConstraint ? fast_check_1.default.constant(propertyTypeConstraint) : exports.arbitraryPropertyValueType).chain((valueType) => {
        switch (valueType) {
            case "string":
                return fast_check_1.default.string();
            case "number":
                return fast_check_1.default.oneof(fast_check_1.default.integer(), fast_check_1.default.float());
            case "boolean":
                return fast_check_1.default.boolean();
            case "link":
                return exports.arbitraryLinkPropertyValue;
            case "vector2":
                return exports.arbitraryVector2PropertyValue;
            case "vector3":
                return exports.arbitraryVector3PropertyValue;
        }
    });
};
exports.arbitraryPropertyValue = arbitraryPropertyValue;
const arbitraryProperty = () => exports.arbitraryPropertyValueType.chain((valueType) => fast_check_1.default.record({
    uid: fast_check_1.default.uuid(),
    name: fast_check_1.default.string({ minLength: 1, maxLength: 30 }),
    value: (0, exports.arbitraryPropertyValue)(valueType),
    unit: fast_check_1.default.string({ maxLength: 3 }), // Should be able to be undefined, but it breaks local Firestore testing
    valueType: fast_check_1.default.constant(valueType),
}));
exports.arbitraryProperty = arbitraryProperty;
exports.arbitraryPropertiesMap = fast_check_1.default
    .array((0, exports.arbitraryProperty)(), { minLength: 0, maxLength: 10 })
    .map((properties) => {
    return Object.fromEntries(properties.map((property) => [property.uid, property]));
});
//# sourceMappingURL=property.js.map